import { useEffect, useState } from 'react';

import { QuestionCircleOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import { useCustomTranslation } from '../../../hooks/custom-translation';
import { ContactProps } from '../../../services/contact';
import { Personas, PersonasProps } from '../../../services/personas';
import { getPersonasData } from '../../../services/personas/personas-service';
import { Footnote, H4, H5 } from '../../../styles/fonts';
import BarChart from '../../Contacts/Contact/ContactProfile/BarChart';
import ModalPersona from '../../ModalPersonas';
import PersonaIcon from './PersonaIcon';
import {
  Column012,
  Column022,
  Column03,
  Content01,
  Content1,
  Data01,
  Label01,
  LearnMoreButton,
  Offer,
  OfferValue,
  Row01,
  Row012,
  Wrapper,
} from './styles';

interface IProps {
  contactInfo: ContactProps | undefined;
}

const General = ({ contactInfo }: IProps) => {
  console.log('contactInfo enriched', contactInfo?.enriched);
  const { tContactSegmentsEdit } = useCustomTranslation('contactSegmentsEdit');
  const [offerTypes, setOfferTypes] = useState<any>([]);
  const [isModalPersonaOpen, setIsModalPersonaOpen] = useState<boolean>(false);
  const [personas, setPersonas] = useState<PersonasProps>();
  const [personaProfileNumber, setPersonaProfileNumber] = useState<number>();

  const handleCloseModalPersona = () => {
    setIsModalPersonaOpen(false);
  };

  useEffect(() => {
    const newArr = [
      [
        'Status Social',
        contactInfo?.enriched.socialStatus || 0,
        'Tendência a buscar produtos que refletem status social',
      ],
      [
        'Valor Sazonal',
        contactInfo?.enriched.seasonalValue || 0,
        'Tendência a compra de produtos em datas comemorativas',
      ],
      [
        'Vantagem Economica',
        contactInfo?.enriched.economicAdvantage || 0,
        'Tendência a buscar por vantagem econômica na hora de pagar',
      ],
      [
        'Varejo Fisico',
        contactInfo?.enriched.physicalRetail || 79,
        'Tendência a preferir lojas físicas',
      ],
      [
        'Brinde',
        contactInfo?.enriched.gift || 90,
        'Têndencia a preferir ofertas com opção de ganhar um brinde',
      ],
      [
        'Estabilidade',
        contactInfo?.enriched.stability || 0,
        'Têndencia a comprar de forma mais racional',
      ],
      [
        'Instabilidade',
        contactInfo?.enriched.instability || 0,
        'Têndencia a fazer compras de forma mais impulsiva',
      ],
      [
        'Novos métodos de pagamento',
        contactInfo?.enriched.pagOption || 70,
        'Tendência a preferir mais opções de pagamento',
      ],
      [
        'Premium',
        contactInfo?.enriched.premium || 0,
        'Tendência a produtos premium',
      ],
      [
        'Premium Serviço',
        contactInfo?.enriched.premiumService || 0,
        'Tendência a serviços premium',
      ],
      [
        'Confianca Marca',
        contactInfo?.enriched.brandTrust || 0,
        'Tendência a confiar nas marcas',
      ],
      [
        'Consumo Potencial Digital',
        contactInfo?.enriched.digitalConsumptionPotential || 0,
        'Tendência a consumo de forma digital',
      ],
      [
        'Conveniencia',
        contactInfo?.enriched.convenience || 72,
        'Tendência a usar lojas de conveniência',
      ],
      [
        'Custo Benefício',
        contactInfo?.enriched.costBenefit || 75,
        'Tendência a valorizar o custo-beneficio',
      ],
      [
        'ESG (Ambiental, Social e Governamental',
        contactInfo?.enriched.esg || 0,
        'Tendência a se preocupar com questões de meio ambiente, sociais e governamentais',
      ],
      [
        'Experiência de Compra',
        contactInfo?.enriched.shoppingExperience || 0,
        'Tendência a valorizar a expêriencia de compra',
      ],
      [
        'Facilidade de Pagamento',
        contactInfo?.enriched.easeOfPayment || 0,
        'Tendência a preferir opções de facilidade de pagamento',
      ],
      [
        'Influência Consumo Online',
        contactInfo?.enriched.influenceOnlineConsumption || 0,
        'Tendência a ser influenciado(a) por meios digitais',
      ],
      [
        'Influência Consumo Offline',
        contactInfo?.enriched.influenceOfflineConsumption || 0,
        'Tendência a ser influenciado(a) por meios físicos (revistas, jornais, rádio)',
      ],
      [
        'Inovação',
        contactInfo?.enriched.innovation || 0,
        'Tendência à inovação',
      ],
    ];

    const sorted = newArr.sort((a, b) => {
      if (a[1] && b[1]) {
        return (a[1] as number) - (b[1] as number);
      }

      return 0;
    });

    const offers = {
      1: sorted[sorted.length - 1],
      2: sorted[sorted.length - 2],
      3: sorted[sorted.length - 3],
      4: sorted[sorted.length - 4],
      5: sorted[sorted.length - 5],
    };

    setOfferTypes([
      {
        title: offers[1][0],
        value: offers[1][1],
        tooltip: offers[1][2],
      },
      {
        title: offers[2][0],
        value: offers[2][1],
        tooltip: offers[2][2],
      },
      {
        title: offers[3][0],
        value: offers[3][1],
        tooltip: offers[3][2],
      },
      {
        title: offers[4][0],
        value: offers[4][1],
        tooltip: offers[4][2],
      },
      {
        title: offers[5][0],
        value: offers[5][1],
        tooltip: offers[5][2],
      },
    ]);
  }, [contactInfo]);

  useEffect(() => {
    console.log('personas dsfdsfd', personas);
    if (!personas) {
      getPersonasData().then((value: PersonasProps) => setPersonas(value));
    }
  }, [setPersonas, personas]);

  useEffect(() => {
    personas?.personas.map((p: Personas, index) => {
      const segmentName =
        contactInfo?.enriched.segmentName?.toLowerCase() || '';
      const personaName = p.name?.toLowerCase() || '';

      // Pega as 3 primeiras letras do segmentName (ex: "tradicionais" -> "tra")
      const firstThreeLetters = segmentName.slice(0, 3);

      if (personaName.includes(firstThreeLetters)) {
        return setPersonaProfileNumber(index);
      }
      setPersonaProfileNumber(index);
      return null;
    });
  }, [contactInfo?.enriched.segmentName, personas]);

  return (
    <>
      <Content01>
        <Column012>
          <Row01>
            <H4 weight="medium">{tContactSegmentsEdit('persona')}</H4>
            <Wrapper>
              <PersonaIcon persona="Compassível" />
              <Content1>
                <H5 weight="medium">
                  {contactInfo?.enriched.segmentName || 'Compassível'}
                </H5>
                <LearnMoreButton
                  weight="medium"
                  color="#722ED1"
                  onClick={() => setIsModalPersonaOpen(true)}
                >
                  {tContactSegmentsEdit('learn_more')}
                </LearnMoreButton>
              </Content1>
            </Wrapper>
          </Row01>
        </Column012>
        <Column022>
          <Row01>
            <Data01>
              <H4 weight="medium">{tContactSegmentsEdit('personality')}</H4>
              <Label01>
                <Footnote>{tContactSegmentsEdit('introvert')}</Footnote>
                <Footnote>{tContactSegmentsEdit('extroverted')}</Footnote>
              </Label01>
              <BarChart value={contactInfo?.enriched.scoreExtr || 50} />
              <Label01>
                <Footnote>{tContactSegmentsEdit('stable')}</Footnote>
                <Footnote>{tContactSegmentsEdit('neuroticism')}</Footnote>
              </Label01>
              <BarChart value={contactInfo?.enriched.scoreNeur || 50} />
              <Label01>
                <Footnote>{tContactSegmentsEdit('undisciplined')}</Footnote>
                <Footnote>{tContactSegmentsEdit('conscientiousness')}</Footnote>
              </Label01>
              <BarChart value={contactInfo?.enriched.scoreCons || 50} />
              <Label01>
                <Footnote>{tContactSegmentsEdit('traditional')}</Footnote>
                <Footnote>
                  {tContactSegmentsEdit('open_to_experiences')}
                </Footnote>
              </Label01>
              <BarChart value={contactInfo?.enriched.scoreExtr || 50} />
            </Data01>
          </Row01>
        </Column022>
        <Column03>
          <Row012>
            <H4 weight="medium">
              {tContactSegmentsEdit('recommended_offer_types')}
            </H4>
            {offerTypes &&
              offerTypes.map((offer: any) => (
                <Offer key={offer.title}>
                  <Tooltip
                    key={offer.title}
                    title={offer.tooltip}
                    className="tooltip"
                    overlayInnerStyle={{
                      fontSize: '0.875rem',
                      lineHeight: '1.375rem',
                    }}
                  >
                    <QuestionCircleOutlined />
                    <span>{offer.title}</span>
                  </Tooltip>

                  <OfferValue>{`${offer.value || 0}%`}</OfferValue>
                </Offer>
              ))}
          </Row012>
        </Column03>
      </Content01>
      {console.log('personaProfileNumber', personaProfileNumber)}
      {personas && (personaProfileNumber || personaProfileNumber === 0) && (
        <ModalPersona
          visible={isModalPersonaOpen}
          onCancel={handleCloseModalPersona}
          onOk={handleCloseModalPersona}
          personaData={personas}
          personaProfile={personaProfileNumber}
        />
      )}
    </>
  );
};

export default General;
